import React from "react";
import {
  ListItem,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Box,
} from "@mui/material";
import "../component/pages/Job/ProcessTable.css";
import { formattedDate } from "./formattedDate";
import {
  formatDecimalHoursToHoursMinutes,
  formatDecimalMinutesToMinutesSeconds,
} from "../utils/timeHelper";
function ViewDrillingTable({ processTableData }) {
  // Common cell style
  const cellStyle = {
    borderRight: "1px solid rgba(21, 20, 20, 0.99)",
    padding: "6px 8px",
    whiteSpace: "nowrap",
  };

  // Header cell style
  const headerCellStyle = {
    ...cellStyle,
    color: "#fff",
    backgroundColor: "#1D5393",
  };

  // Idle code header style (different background)
  const idleHeaderCellStyle = {
    ...cellStyle,
    color: "#fff",
    backgroundColor: "#5361b5", // Slightly different shade
    fontWeight: "bold",
  };
  return (
    <>
      <Table sx={{ minWidth: 350 }} aria-label="simple table">
        <TableHead>
          <TableRow sx={{ backgroundColor: "#1D5393" }}>
            <TableCell align="center" sx={headerCellStyle}>
              Sr.No
            </TableCell>

            <TableCell align="center" sx={headerCellStyle}>
              Process
            </TableCell>
            <TableCell align="center" sx={headerCellStyle}>
              Description
            </TableCell>
            <TableCell align="center" sx={headerCellStyle}>
              Machine Name
            </TableCell>
            <TableCell align="center" sx={headerCellStyle}>
              Tooling Used
            </TableCell>
            <TableCell align="center" sx={headerCellStyle}>
              DIA
            </TableCell>
            <TableCell align="center" sx={headerCellStyle}>
              RPM
            </TableCell>
            <TableCell align="center" sx={headerCellStyle}>
              Length
            </TableCell>

            <TableCell align="center" sx={headerCellStyle}>
              Feed(MM/MIN)
            </TableCell>

            <TableCell align="center" sx={headerCellStyle}>
              NOH
            </TableCell>
            <TableCell align="center" sx={headerCellStyle}>
              Required Dimension
            </TableCell>
            <TableCell align="center" sx={headerCellStyle}>
              Actual Dimension
            </TableCell>
            <TableCell align="center" sx={headerCellStyle}>
              EST.HRS
            </TableCell>
            <TableCell align="center" sx={headerCellStyle}>
              Estimated CT(min)
            </TableCell>
            <TableCell align="center" sx={headerCellStyle}>
              Actual CT(min)
            </TableCell>
            <TableCell align="center" sx={headerCellStyle}>
              Start Date
            </TableCell>
            <TableCell align="center" sx={headerCellStyle}>
              Start Time
            </TableCell>
            <TableCell align="center" sx={headerCellStyle}>
              End Date
            </TableCell>
            <TableCell align="center" sx={headerCellStyle}>
              End Time
            </TableCell>

            <TableCell align="center" sx={headerCellStyle}>
              User Name
            </TableCell>
            <TableCell align="center" sx={headerCellStyle}>
              Remark
            </TableCell>
            <TableCell align="center" sx={headerCellStyle}>
              CreatedAt
            </TableCell>
            <TableCell align="center" sx={headerCellStyle}>
              Last UpdatedAt
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {processTableData &&
            processTableData?.map((row, rowIndex) => (
              <>
                <TableRow
                  key={rowIndex}
                  style={{
                    color: "#fff",
                    backgroundColor:
                      !isNaN(row?.actualCT) && row?.actualCT !== 0
                        ? row?.estimatedCT >= row?.actualCT
                          ? "#a7f3d0"
                          : "#FE8A96"
                        : "inherit",
                  }}
                >
                  <TableCell align="center" sx={cellStyle}>
                    {rowIndex + 1}
                  </TableCell>

                  <TableCell align="center" sx={cellStyle}>
                    {row.process}
                  </TableCell>
                  <TableCell align="center" sx={cellStyle}>
                    {row.description}
                  </TableCell>
                  <TableCell align="center" sx={cellStyle}>
                    {row.machineName}
                  </TableCell>
                  <TableCell align="center" sx={cellStyle}>
                    {row.toolingUsed}
                  </TableCell>
                  <TableCell align="center" sx={cellStyle}>
                    {row.dia}
                  </TableCell>
                  <TableCell align="center" sx={cellStyle}>
                    {row.rpm}
                  </TableCell>
                  <TableCell align="center" sx={cellStyle}>
                    {row.length}
                  </TableCell>
                  <TableCell align="center" sx={cellStyle}>
                    {row.feed}
                  </TableCell>
                  <TableCell align="center" sx={cellStyle}>
                    {row.noh}
                  </TableCell>
                  <TableCell align="center" sx={cellStyle}>
                    {row?.requiredDimension}
                  </TableCell>
                  <TableCell align="center" sx={cellStyle}>
                    {row?.actualDimension}
                  </TableCell>
                  <TableCell align="center" sx={cellStyle}>
                    {row.estimatedHrs
                      ? formatDecimalHoursToHoursMinutes(row.estimatedHrs)
                      : "-"}
                  </TableCell>
                  <TableCell align="center" sx={cellStyle}>
                    {row.estimatedCT
                      ? formatDecimalMinutesToMinutesSeconds(row.estimatedCT)
                      : "-"}
                  </TableCell>
                  <TableCell align="center" sx={cellStyle}>
                    {row.actualCT
                      ? formatDecimalMinutesToMinutesSeconds(row.actualCT)
                      : "-"}
                  </TableCell>

                  <TableCell align="center" sx={cellStyle}>
                    {row.startDate ? formattedDate(row.startDate) : "-"}
                  </TableCell>
                  <TableCell align="center" sx={cellStyle}>
                    {row.startTime ? row.startTime : "-"}
                  </TableCell>
                  <TableCell align="center" sx={cellStyle}>
                    {row.endDate ? formattedDate(row.endDate) : "-"}
                  </TableCell>
                  <TableCell align="center" sx={cellStyle}>
                    {row.endTime ? row.endTime : "-"}
                  </TableCell>

                  <TableCell align="center" sx={cellStyle}>
                    {row.userName ? row.userName : "-"}
                  </TableCell>
                  <TableCell align="center" sx={cellStyle}>
                    {row.remark ? row.remark : "-"}
                  </TableCell>
                  <TableCell align="center" sx={cellStyle}>
                    {formattedDate(row.createdAt) ?? "-"}
                  </TableCell>
                  <TableCell align="center" sx={cellStyle}>
                    {formattedDate(row.updatedAt) ?? "-"}
                  </TableCell>
                </TableRow>
                {/* Idle code header row */}
                {row?.idleCode?.length > 0 ? (
                  <TableRow>
                    <TableCell
                      align="center"
                      sx={idleHeaderCellStyle}
                    ></TableCell>

                    <TableCell align="center" sx={idleHeaderCellStyle}>
                      Sr.No
                    </TableCell>
                    <TableCell align="center" sx={idleHeaderCellStyle}>
                      Code
                    </TableCell>
                    <TableCell align="center" sx={idleHeaderCellStyle}>
                      Start Date
                    </TableCell>
                    <TableCell align="center" sx={idleHeaderCellStyle}>
                      Start Time
                    </TableCell>
                    <TableCell align="center" sx={idleHeaderCellStyle}>
                      End Date
                    </TableCell>
                    <TableCell align="center" sx={idleHeaderCellStyle}>
                      End Time
                    </TableCell>
                    <TableCell align="center" sx={idleHeaderCellStyle}>
                      Duration
                    </TableCell>
                    {/* Empty cells for remaining columns */}
                    {[...Array(13)].map((_, i) => (
                      <TableCell
                        key={`header-${i}`}
                        align="center"
                        sx={idleHeaderCellStyle}
                      ></TableCell>
                    ))}
                  </TableRow>
                ) : null}

                {/* Idle code data rows */}
                {row?.idleCode?.length > 0
                  ? row.idleCode.map((idle, idx) => (
                      <TableRow key={idx}>
                        <TableCell align="center" sx={cellStyle}></TableCell>

                        <TableCell align="center" sx={cellStyle}>
                          {idx + 1}
                        </TableCell>
                        <TableCell align="center" sx={cellStyle}>
                          {idle?.name}
                        </TableCell>
                        <TableCell align="center" sx={cellStyle}>
                          {formattedDate(idle?.startDate)}
                        </TableCell>
                        <TableCell align="center" sx={cellStyle}>
                          {idle?.startTime}
                        </TableCell>
                        <TableCell align="center" sx={cellStyle}>
                          {formattedDate(idle?.endDate)}
                        </TableCell>
                        <TableCell align="center" sx={cellStyle}>
                          {idle?.endTime}
                        </TableCell>
                        <TableCell align="center" sx={cellStyle}>
                          {idle?.timeDifference}
                        </TableCell>
                        {/* Empty cells for remaining columns */}
                        {[...Array(13)].map((_, i) => (
                          <TableCell
                            key={`empty-${i}`}
                            align="center"
                            sx={cellStyle}
                          ></TableCell>
                        ))}
                      </TableRow>
                    ))
                  : null}
              </>
            ))}
        </TableBody>
      </Table>
    </>
  );
}

export default ViewDrillingTable;
